export const manifest = {
  screens: {
    scr_rk9qvz: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_nzrx64: { name: "About", route: "/about", position: {"x":1560,"y":220} },
    scr_3op4hg: { name: "Services", route: "/services", position: {"x":2960,"y":220} },
    scr_lqvkjb: { name: "Property Management", route: "/property-management", position: {"x":160,"y":2200} },
    scr_70fvo5: { name: "Business & Finance", route: "/business-finance-services", position: {"x":1560,"y":2200} },
    scr_sbevae: { name: "Legal, Licensing & Expat", route: "/legal-licensing-expat-services", position: {"x":2960,"y":2200} },
    scr_m0w7gk: { name: "Contact", route: "/contact", position: {"x":4360,"y":220} },
  },
  sections: {
    sec_ltmy25: { name: "Main Navigation", x: 0, y: 0, width: 5720, height: 1180 },
    sec_fqu7ts: { name: "Service Offerings", x: 0, y: 1980, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ltmy25", children: [
      { kind: "screen", id: "scr_rk9qvz" },
      { kind: "screen", id: "scr_nzrx64" },
      { kind: "screen", id: "scr_3op4hg" },
      { kind: "screen", id: "scr_m0w7gk" },
    ] },
    { kind: "section", id: "sec_fqu7ts", children: [
      { kind: "screen", id: "scr_lqvkjb" },
      { kind: "screen", id: "scr_70fvo5" },
      { kind: "screen", id: "scr_sbevae" },
    ] },
  ],
}
